import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppMaterialModule } from '@app/app-material.module';
import { AnimationsModule } from '@shared/animations/animations.module';
import { ComponentsModule } from '@shared/components/components.module';
import { FrotaContratadaComponent } from '@modules/frota-contratada/pages/frota-contratada/frota-contratada.component';
import { FrotaContratadaController } from '@modules/frota-contratada/controllers';
import { VincularCondutorComponent } from '@modules/frota-contratada/components/vincular-condutor/vincular-condutor.component';
import { AnexosVeiculoComponent } from './components/vincular-condutor/anexos/anexos-veiculo.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    FrotaContratadaComponent,
    VincularCondutorComponent,
    AnexosVeiculoComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    ComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
  ],
  providers: [provideNgxMask(maskConfig), FrotaContratadaController],
})
export class FrotaContratadaModule { }
